import { storyLocalRepository } from "@/features/story/repositories/story.local.repository"
import { StoryRepository } from "@/features/story/repositories/story.repository"
import { StoryEntity } from "@/shared/lib/db"

class StoryService {
    constructor(private repo: StoryRepository) {}
    
    getByKeys(keys: string[]): Promise<StoryEntity[]> {
        return this.repo.getByKeys(keys)
    }
    async getByTitle(projectId: string, title: string): Promise<StoryEntity | undefined> {
        const stories = await this.getAll(projectId)
        return stories.find(s => s.title === title)
    }
    save(story: StoryEntity): Promise<void> {
        return this.repo.save(story)
    }
    delete(projectId: string, fileName: string): Promise<void> {
        return this.repo.delete(projectId + '-' + fileName)
    }
    getAll(projectId: string): Promise<StoryEntity[]> {
        return  this.repo.getAll((story) => story.projectId === projectId)
    }
}

export const storyService = new StoryService(storyLocalRepository)